<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-0">
        {{ questionText }}
      </p>
      <v-radio-group v-model="inputs.input1" :disabled="!allowEditing" class="mt-1 pl-6">
        <div v-for="option in options1" :key="option.value">
          <v-radio class="d-inline-block" :value="option.value">
            <template #label>
              <stemble-latex :content="option.text" />
            </template>
          </v-radio>
        </div>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'UPEISafety8',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
      },
    };
  },
  computed: {
    questionNumber() {
      return this.taskState.getValueBySymbol('questionNumber').content;
    },
    questionText() {
      if (this.questionNumber.value === 1) {
        return 'Is it okay for flammable liquids and combustible materials to be around flames or sparks?';
      } else {
        return 'What should you do if you see any flames on your skin or clothes?';
      }
    },
    options1() {
      if (this.questionNumber.value === 1) {
        return [
          {
            text: 'Yes',
            value: '1',
          },
          {
            text: 'No',
            value: '2',
          },
          {
            text: 'As long as there is a fire extinguisher nearby',
            value: '3',
          },
        ];
      } else {
        return [
          {
            text: 'Run around',
            value: '1',
          },
          {
            text: 'Stop, Drop, and Roll',
            value: '2',
          },
          {
            text: 'Blow on it',
            value: '3',
          },
          {
            text: 'Dab and take a selfie for the likes on social media',
            value: '4',
          },
        ];
      }
    },
  },
};
</script>
